export const ARTIFACT_TYPES = Object.freeze({
  TIMELINE_EVENT: 'timeline_event',
  KNOWLEDGE_ITEM: 'knowledge_item',
  GOAL: 'goal',
  MEDICATION_UPDATE: 'medication_update',
  DOCUMENT_REFERENCE: 'document_reference',
  SOURCE_ONLY: 'source_only',
});

const MEDICATION_ARTIFACT_TOKENS = new Set([
  'medication',
  'medication_change',
  'medication_dose',
  'medication_update',
  'medication_admin',
  'meds',
]);

const normalizeToken = (value = '') => (
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_')
);

export const normalizeArtifactType = (value = '') => {
  const normalized = normalizeToken(value);
  return Object.values(ARTIFACT_TYPES).includes(normalized) ? normalized : '';
};

export const isKnowledgeItemArtifact = (value = '') => (
  normalizeArtifactType(value) === ARTIFACT_TYPES.KNOWLEDGE_ITEM
);

export const resolveTimelineArtifactType = (record = {}) => {
  const tokens = [
    record.artifactType,
    record.category,
    record.logCategory,
    record.candidateType,
    record.type,
    record.record?.category,
    record.record?.candidateType,
    record.record?.type,
    record.metadata?.candidateType,
    record.metadata?.suggestedRecord?.candidateType,
    record.metadata?.suggestedRecord?.record?.category,
    record.metadata?.suggestedRecord?.record?.candidateType,
    record.source?.category,
    record.source?.type,
  ].map(normalizeToken);

  return tokens.some((token) => MEDICATION_ARTIFACT_TOKENS.has(token))
    ? ARTIFACT_TYPES.MEDICATION_UPDATE
    : ARTIFACT_TYPES.TIMELINE_EVENT;
};
